import type { AssetInfoStudyProps } from "./asset-info-study.type";

import { WarningFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { FlexContainerText } from "@/modules/flex-container";

export const AssetInfoStudy = ({ asset }: AssetInfoStudyProps) => {
  const { t } = useTranslation();

  const { study_frequency_in_month, last_study, next_study, is_study_overdue } =
    asset;

  return (
    <>
      {study_frequency_in_month && (
        <FlexContainerText
          value={t("asset:form.studyFrequency.value", {
            nbrOfMonths: study_frequency_in_month,
          })}
          label={t("asset:form.studyFrequency.label")}
          tooltip={t("asset:form.studyFrequency.tooltip")}
        />
      )}
      {last_study && (
        <FlexContainerText
          value={last_study}
          label={t("asset:form.lastStudy.label")}
          tooltip={t("asset:form.lastStudy.tooltip")}
        />
      )}
      {next_study && (
        <FlexContainerText
          value={next_study}
          label={t("asset:form.nextStudy.label")}
          tooltip={t("asset:form.nextStudy.tooltip")}
        />
      )}
      {is_study_overdue && (
        <FlexContainerText
          value={t("asset:form.isStudyOverdue.label")}
          icon={
            <WarningFilled style={{ fontSize: "20px", color: "#f29d41" }} />
          }
        />
      )}
    </>
  );
};
